import React,{Component} from "react"
import {Container,CardDeck,Card,CardBody,CardFooter,CardHeader,Media} from 'reactstrap'
class About extends Component{

    render(){

        return(

            <div>
            <main>
            <section className="section-profile-cover section-shaped bg-light" >
                    
            <Container>
            <header className="pt-2 pb-2"> <h2> About Us </h2></header>
                <hr/><CardDeck>
                    <Card className="bg-secondary text-center"> <h3 className="text-center px-100 py-100"> Photo </h3> </Card>
                    <Card className="px-3 py-3"> <h2 className="py-2"> About CalBit Services</h2> 
                     <Media className="py-1">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sed voluptate nihil eum consectetur similique? Consectetur, quod, incidunt, harum nisi dolores delectus reprehenderit voluptatem perferendis dicta dolorem non blanditiis ex fugiat.</Media>

                     <Media className="py-1">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe, magni, aperiam vitae illum voluptatum aut sequi impedit non velit ab ea pariatur sint quidem corporis eveniet. Odit, temporibus reprehenderit dolorum!</Media>
                    
                    <Media className="py-1"> Lorem ipsum dolor sit amet, consectetur adipisicing elit. Et, consequuntur, modi mollitia corporis ipsa voluptate corrupti eum ratione ex ea praesentium quibusdam? Aut, in eum facere corrupti necessitatibus perspiciatis quis?</Media>
                    </Card>
                </CardDeck>
                <hr />
                <header className="mt-2 pt-2 pb-2"> <h2> Our Team </h2></header>
                <hr/>
                    <CardDeck>
                        <Card>
                            <CardHeader> ... Photo ...</CardHeader>
                            <CardBody> <h3 className="text-center">Team Member </h3> <h4 className="text-muted text-center" > Position </h4>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus aut mollitia eum ipsum fugiat odio officiis odit.</CardBody>
                            <CardFooter className="text-center">name@example.com</CardFooter>
                        </Card>

                        <Card>
                        <CardHeader> ... Photo ...</CardHeader>
                        <CardBody><h3 className="text-center">Team Member </h3> <h4 className="text-muted text-center" > Position </h4> Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus aut mollitia eum ipsum fugiat odio officiis odit. </CardBody>
                        <CardFooter className="text-center">name@example.com</CardFooter>
                    </Card>

                    <Card>
                    <CardHeader> ... Photo ...</CardHeader>
                    <CardBody> <h3 className="text-center">Team Member </h3> <h4 className="text-muted text-center" > Position </h4>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus aut mollitia eum ipsum fugiat odio officiis odit.</CardBody>
                    <CardFooter className="text-center"> name@example.com</CardFooter>
                </Card>
                    </CardDeck>
                    <hr/>
                    <header className="mt-2 pt-2 pb-2"> <h2> Our Customers </h2> </header>
                    
                    <hr/>
                    <CardDeck>
                        <Card> <CardBody  className="text-center bg-secondary"> Photo </CardBody> </Card>
                        <Card> <CardBody className="text-center bg-secondary"> Photo </CardBody> </Card>
                        <Card> <CardBody className="text-center bg-secondary"> Photo </CardBody> </Card>
                        <Card> <CardBody className="text-center bg-secondary"> Photo </CardBody> </Card>
                        <Card> <CardBody className="text-center bg-secondary"> Photo </CardBody> </Card>
                    </CardDeck>
                    </Container>
            </section>
            </main>
            </div>
        )
    }

}

export default About;


// WEBPACK FOOTER //
// ./src/pages/About.js